import * as React from 'react';
import { useEffect } from 'react';
import { Button, Row, Space, Tooltip, Alert, Input, Dropdown } from 'antd';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./styles/ListHeader.scss";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
const { Search } = Input;

export type Action = {
    singleName: string,
    multiName: string,
    tag: string,
    noSelect: boolean | null,
    hidden: false | null,
    multiSelect: boolean,
    forceDisable: boolean,
    icon: IconDefinition,
    menu: JSX.Element | undefined,
    onClick: () => void | undefined | Promise<void>,
    alwaysEnabled?: boolean,
    popover?: any,
    popoverProps?: any
}

type Props = {
    actions: Action[],
    tag:string,
    selectedItems: number,
    totalItems: number,
    unselectAll: () => void,
    searchPlaceholder: string,
    searchTooltip?: string,
    onSearch: (search:string) => void,
    reset?: boolean,
    ignoreSearch: boolean,
    noSelection?: boolean,
    customActionRow?: React.ReactNode,
    compact?: boolean,
    extraActions?: any
    useCompactSize: boolean
}

const ListHeader : React.FC<Props> = ({actions,tag,onSearch,searchPlaceholder,selectedItems,totalItems,unselectAll,reset = false, ignoreSearch = false, noSelection = false, customActionRow = null, compact = false, searchTooltip = null, extraActions = null, useCompactSize = false}) => {

    useEffect(() => {
        if (reset && !ignoreSearch)
            onSearch('');
    }, [])

    const buttonSize = ():string => {
        return useCompactSize ? "32px" : "40px"
    }

    const buttonFontSize = ():number => {
        return useCompactSize ? 15 : 18
    }

    const search = () => {
        return <Tooltip title={searchTooltip ?? searchPlaceholder} mouseEnterDelay={0.5}>
        <Search
            id={tag + "SearchBar"}
            placeholder={searchPlaceholder}
            allowClear
            size={compact || useCompactSize ? "middle" : "large"}
            onSearch={onSearch}
            style={{width: compact || useCompactSize ? '100%' : 320, marginTop: compact ? 10 : 0, minWidth: useCompactSize ? 240 : 0}}
            onChange={(e) => onSearch(e.target.value)}
        />
        </Tooltip>
    }

    return (
        <>
        <Row id={tag + "Header"} className="search-table-row" justify="space-between" style={{marginBottom: '10px'}}>
            <div>
                {customActionRow}
                {!!!customActionRow && actions.map((x,key) => {
                    if(x.hidden) return null;

                    var disable = (!x.multiSelect && selectedItems > 1) || selectedItems === 0 || x.forceDisable;
                    if(x.noSelect !== null && x.noSelect && !x.forceDisable && selectedItems === 0) {
                        disable = false;
                    }
                    if(x.alwaysEnabled) {
                        disable = false;
                    }
                    if(x.popover) {
                        return (
                            <React.Fragment key={key}>
                            <x.popover
                                {...x.popoverProps}
                                inner={
                                    <Tooltip title={selectedItems > 1 ? x.multiName : x.singleName} mouseEnterDelay={0.5}>
                                        <Button id={x.tag + "Button"} shape="circle" style={{width: buttonSize(), height: buttonSize()}} disabled={disable} aria-label={selectedItems > 1 ? x.multiName : x.singleName}>
                                            <FontAwesomeIcon icon={x.icon as IconProp} aria-hidden="true"/>
                                        </Button>
                                    </Tooltip>
                                }
                            />
                            &nbsp;&nbsp;
                            </React.Fragment>
                        )
                    }
                    if(x.menu !== undefined) {
                        return (
                            <React.Fragment key={key}>
                            <Dropdown
                            placement="bottomCenter"
                            overlay={x.menu}
                            trigger={['click']}
                            disabled={disable}
                            >
                                <Tooltip title={selectedItems > 1 ? x.multiName : x.singleName} mouseEnterDelay={0.5}>
                                    <Button id={x.tag + "Button"} shape="circle" style={{width: buttonSize(), height: buttonSize(), fontSize: buttonFontSize()}} disabled={disable} aria-label={selectedItems > 1 ? x.multiName : x.singleName}>
                                        <FontAwesomeIcon icon={x.icon as IconProp} aria-hidden="true"/>
                                    </Button>
                                </Tooltip>
                            </Dropdown>
                            &nbsp;&nbsp;
                            </React.Fragment>
                        )
                    } else {
                        return (
                            <React.Fragment key={key}>
                            <Tooltip title={selectedItems > 1 ? x.multiName : x.singleName} mouseEnterDelay={0.5}>
                                <Button id={x.tag + "Button"} shape="circle" style={{width: buttonSize(), height: buttonSize(), fontSize: buttonFontSize()}} disabled={disable} onClick={x.onClick} aria-label={selectedItems > 1 ? x.multiName : x.singleName}>
                                    <FontAwesomeIcon icon={x.icon as IconProp} aria-hidden="true"/>
                                </Button>
                            </Tooltip>
                            &nbsp;&nbsp;
                            </React.Fragment>
                        )
                    }
                })}
            </div>
            {!!searchPlaceholder && !!!compact && !ignoreSearch &&
                <Space>
                    {search()}{extraActions}
                </Space>
            }
        </Row>
        {compact && searchPlaceholder && !ignoreSearch &&
            search()
        }
        {selectedItems > 0
            ?   <Alert
                    message={`${selectedItems} of ${totalItems} selected`}
                    type="info"
                    className="custom-list-header"
                    showIcon
                    action={
                        <Button size="small" type="ghost" onClick={unselectAll}>Unselect All</Button>
                    }
                    style={compact ? {marginTop: 10} : {}}
                />
            : !noSelection && <div style={{height: '33px', marginTop: compact ? 10 : 0}}/>
        }
        </>
    )
}

export default ListHeader;
